import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import useForkRef from '@mui/utils/useForkRef';
import { Button } from '../button/button.js';

var DateRangeButtonField = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    disabled = props.disabled,
    _props$InputProps = props.InputProps,
    _props$InputProps2 = _props$InputProps === undefined ? {} : _props$InputProps,
    containerRef = _props$InputProps2.ref,
    _props$inputProps = props.inputProps,
    _props$inputProps2 = _props$inputProps === undefined ? {} : _props$inputProps,
    ariaLabel = _props$inputProps2['aria-label'],
    buttonText = props.buttonText,
    handleClick = props.handleClick,
    otherProps = __rest(props, ["id", "disabled", "InputProps", "inputProps", "buttonText", "handleClick"]);
  var handleRef = useForkRef(ref, containerRef);
  return jsx(Button, Object.assign({}, otherProps, {
    id: id,
    disabled: disabled,
    ref: handleRef,
    "aria-label": ariaLabel,
    onClick: function onClick(e) {
      handleClick(e);
    },
    children: buttonText
  }));
});
DateRangeButtonField.fieldType = 'single-input';

export { DateRangeButtonField };
